import {
  IndustryTypes,
  NumberOfEmployees,
} from '@payaca/types/companyInformationTypes';

export const INDUSTRY_OPTIONS = [
  { label: 'Appliance repair', value: IndustryTypes.APPLIANCE_REPAIR },
  { label: 'Carpentry', value: IndustryTypes.CARPENTRY },
  {
    label: 'Commercial construction',
    value: IndustryTypes.COMMERCIAL_CONSTRUCTION,
  },
  { label: 'Electrical', value: IndustryTypes.ELECTRICAL },
  { label: 'Fencing & decking', value: IndustryTypes.FENCING_AND_DECKING },
  { label: 'Flooring', value: IndustryTypes.FLOORING },
  { label: 'Glazing', value: IndustryTypes.GLAZING },
  { label: 'Landscaping & lawns', value: IndustryTypes.LANDSCAPING_AND_LAWNS },
  { label: 'Locksmith services', value: IndustryTypes.LOCKSMITH_SERVICES },
  {
    label: 'Painting & decorating',
    value: IndustryTypes.PAINTING_AND_DECORATING,
  },
  { label: 'Pest control', value: IndustryTypes.PEST_CONTROL },
  { label: 'Pool & spa services', value: IndustryTypes.POOL_AND_SPA_SERVICES },
  { label: 'Plastering', value: IndustryTypes.PLASTERING },
  { label: 'Plumbing', value: IndustryTypes.PLUMBING },
  { label: 'Heating', value: IndustryTypes.HEATING },
  { label: 'Property maintenance', value: IndustryTypes.PROPERTY_MAINTENANCE },
  {
    label: 'Residential renovations',
    value: IndustryTypes.RESIDENTIAL_RENOVATIONS,
  },
  { label: 'Roofing', value: IndustryTypes.ROOFING },
  { label: 'Security services', value: IndustryTypes.SECURITY_SERVICES },
  { label: 'Tiling', value: IndustryTypes.TILING },
  { label: 'Tree care', value: IndustryTypes.TREE_CARE },
  { label: 'Window cleaning', value: IndustryTypes.WINDOW_CLEANING },
  { label: 'Other...', value: IndustryTypes.OTHER },
];

export const NUMBER_OF_EMPLOYEES_OPTIONS = [
  { label: '1', value: NumberOfEmployees.ONE },
  { label: '2-5', value: NumberOfEmployees.TWO_TO_FIVE },
  { label: '6-20', value: NumberOfEmployees.SIX_TO_TWENTY },
  { label: '21-50', value: NumberOfEmployees.TWNETY_ONE_TO_FIFTY },
  { label: '51-200', value: NumberOfEmployees.FIFTY_ONE_TO_TWO_HUNDRED },
  { label: '200+', value: NumberOfEmployees.TWO_HUNDRED_PLUS },
];
